import { LocalStorageKeys } from '@/types';
import { getDeepLinkTargetUrl, isDeepLinkQuery } from '@/utils/deep-link';
export default (function (_a) {
    var route = _a.route;
    var isDeepLink = isDeepLinkQuery(route.query) || !!getDeepLinkTargetUrl(route.fullPath);
    if (route.fullPath.startsWith('/companies') && !isDeepLink) {
        localStorage.setItem(LocalStorageKeys.LastURL, route.fullPath);
    }
});
